jQuery(document).ready(function ($) {
    $.fn.restart = function () {
        const _this = this;

        dataLayer.push({
            event: 'restart_calculator'
        });

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                action: 'arise_pc_reset_block',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                console.log('submitting form data');

                _this.parent().addClass('loading');
            },

            success: function (response) {
                _this.parent().removeClass('loading');

                window.arise_pc_state.services = [];
                window.arise_pc_state.current_response = false;
                window.arise_pc_state.next_question = -1;

                const new_block = response.data.block;

                _this.parent().fadeOut(250);

                const container = _this.parent().parent();

                container.html('');
                container.append(new_block);

                $('html, body').animate({ scrollTop: container.offset().top - $('.heading-links').outerHeight() }, 250);
            },

            complete: function () {
                _this.parent().removeClass('loading');
            }
        });
    }

    $(document).on('click', '#pc-restart', function (event) {
        event.preventDefault();

        $(this).restart();
    });
});